import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Container = styled.div(() => ({
    padding: "24px 32px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const TitleText = styled.span({
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: "bold",
});

export const CloseIcon = styled.span(props => ({
    color: theme(props).icons.color,
    cursor: "pointer",
    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));
